import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '../../utils/cn'

const circleVariants = cva('rounded-full', {
  variants: {
    size: {
      default: 'size-4',
      xs: 'size-1',
      sm: 'size-2',
      lg: 'size-5'
    },
    color: {
      default: 'bg-primary',
      valid: 'bg-success-foreground',
      error: 'bg-destructive-foreground',
      warning: 'bg-warning',
      info: 'bg-info'
    }
  },
  defaultVariants: {
    size: 'default',
    color: 'default'
  }
})

export type CircleProps = React.ComponentProps<'div'> &
  VariantProps<typeof circleVariants> &
  React.PropsWithChildren

function Circle({ className, size, color, ...props }: CircleProps) {
  return (
    <div data-slot="circle" className={cn(circleVariants({ size, color, className }))} {...props} />
  )
}

export { Circle }
